export default "__VITE_ASSET__edc8b862__"